import script from "./VideoOutputSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoOutputSelector.vue?vue&type=script&lang=ts&setup=true"

import "./VideoOutputSelector.vue?vue&type=style&index=0&id=57a04063&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a04063"]])

export default __exports__